import script from "./Empty.vue?vue&type=script&lang=ts&setup=true"
export * from "./Empty.vue?vue&type=script&lang=ts&setup=true"

import "./Empty.vue?vue&type=style&index=0&id=e44e2e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e44e2e1e"]])

export default __exports__